import {apolloClient} from '@/setup/apollo-setup';
import {error, newItemSuccess, updateItemSuccess, deleteItemSuccess} from '@/utils/notification';
import {
  GET_ACADEMICPERIOD,
  GET_ACADEMICPERIODS,
  ADD_ACADEMICPERIOD,
  UPDATE_ACADEMICPERIOD,
  DELETE_ACADEMICPERIOD
} from '@/queries/modules/common-data/academic-period';

export async function getAcademicPeriods(context) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_ACADEMICPERIODS,
        fetchPolicy: 'network-only'
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setAcademicPeriods', data.getAcademicPeriods);
      context.commit('setSuccess', null);
      return data.getAcademicPeriods
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getAcademicPeriod(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_ACADEMICPERIOD,
        variables: payload
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setAcademicPeriod', data.getAcademicPeriod);
      context.commit('setSuccess', null);
      return data.getAcademicPeriod
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function addAcademicPeriod(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: ADD_ACADEMICPERIOD,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const academicPeriods = [...context.state.academicPeriods];
      academicPeriods.push(data.addAcademicPeriod);
      context.commit('setAcademicPeriods', academicPeriods);
      context.commit('setSuccess', newItemSuccess(data.addAcademicPeriod.periodCode));

      return data.addAcademicPeriod
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function updateAcademicPeriod(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: UPDATE_ACADEMICPERIOD,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {

      const index = context.state.academicPeriods.findIndex(item => item.id === data.updateAcademicPeriod.id);
      const academicPeriods = [
        ...context.state.academicPeriods.slice(0, index),
        data.updateAcademicPeriod,
        ...context.state.academicPeriods.slice(index + 1)
      ];
      context.commit('setAcademicPeriods', academicPeriods);
      context.commit('setSuccess', updateItemSuccess(data.updateAcademicPeriod.periodCode));

      return data.updateAcademicPeriod
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function deleteAcademicPeriod(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: DELETE_ACADEMICPERIOD,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const index = context.state.academicPeriods.findIndex(item => item.id === data.deleteAcademicPeriod.id);
      const academicPeriods = [
        ...context.state.academicPeriods.slice(0, index),
        ...context.state.academicPeriods.slice(index + 1)
      ];
      context.commit('setAcademicPeriods', academicPeriods);
      context.commit('setSuccess', deleteItemSuccess(data.deleteAcademicPeriod.periodCode));

      return data.deleteAcademicPeriod
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

